export default "__VITE_ASSET__mWG9T1A6__ 100w";